<template>
  <div class="division">
    <div class="line" :style="setDivisionStyle(item)"></div>
  </div>
</template>

<script>
export default {
  name: 'DivisionModule',
  props: [
    'locale',
    'activeLang',
    'isNew',
    'hasPrice',
    'id',
    'moduleIndex',
    'item',
    'itemSetting'
  ],
  methods: {
    setDivisionStyle (column) {
      const divisionData = column.detail.division
      const radius = column.detail.radius && column.detail.radius.active ? column.detail.radius : null
      let styleObj = {
        'border-top-width': `${divisionData.width}px`,
        'border-top-style': divisionData.style,
        'border-top-color': divisionData.color,
        ...radius && {
          'border-radius': `${radius.tl}px ${radius.tr}px ${radius.br}px ${radius.bl}px`
        }
      }
      return styleObj
    }
  }
}
</script>
